const Section6 = () => {
  return <div className="bottom-img"></div>;
};
export default Section6;
